<template>
	<div class="page-dashboard relative">
		<div class="container-fluid">
			<h2 class="text-primary mb-4">{{ $t(title) }}</h2>
			<!-- Table Menu -->
			<div class="table-menu flex-center">
				<!-- filter -->
				<div class="verified-icon-left text-center  ml-a"><i class="material-icons text-white absolute pt-1">sort</i></div>
				<div class="mr-3">
					<md-menu md-align-trigger :md-offset-x="-30">
						<button class="btn btn-filter-last-login p-0 m-0" md-menu-trigger>
								<span class="capitalize" v-if="orderBy === 'id'">{{$t('All')}}</span>
								<span class="capitalize" v-if="orderBy === 'created_at'">{{$t('Created At')}}</span>
								<span class="capitalize" v-if="orderBy === 'action'">{{$t('Action')}}</span>
								<span class="capitalize" v-if="orderBy === 'category'">{{$t('Category')}}</span>
						</button>
						<!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
						<md-menu-content>
							<md-menu-item @click="filterOrder('all')"><span class="text-center minw-85">{{$t('All')}}</span></md-menu-item>
							<md-menu-item @click="filterOrder('created_at')"><span class="text-center minw-85">{{$t('Created At')}}</span></md-menu-item>
							<md-menu-item @click="filterOrder('action')"><span class="text-center minw-85">{{$t('Action')}}</span></md-menu-item>
							<md-menu-item @click="filterOrder('category')"><span class="text-center minw-85">{{$t('Category')}}</span></md-menu-item>
						</md-menu-content>
					</md-menu>
				</div>
				<!-- sort -->
				<div class="verified-icon-left text-center"><i class="material-icons text-white absolute pt-1 text-lg pt-2">filter_list</i></div>
					<div class="mr-3">
						<md-menu md-align-trigger :md-offset-x="-20">
							<button class="btn btn-filter-last-transaction p-0 m-0" md-menu-trigger>
									<span class="tf-none" v-if="sortBy === 'desc'">{{$t('Newest on top')}}</span>
									<span class="tf-none" v-if="sortBy === 'asc'">{{$t('Newest on last')}}</span>
							</button>
							<!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
							<md-menu-content>
								<md-menu-item @click="sortFilter('desc')"><span class="text-center minw-115">{{$t('Newest on top')}}</span></md-menu-item>
								<md-menu-item @click="sortFilter('asc')"><span class="text-center minw-115">{{$t('Newest on last')}}</span></md-menu-item>
							</md-menu-content>
						</md-menu>
					</div>
				<!-- counting -->
				<div class="mr-3">
					<md-menu md-align-trigger md :md-offset-x=10>
						<button class="btn-icon btn p-0 m-0 w-100 btn-click" md-menu-trigger>
								{{ page * limit - (limit - 1) }} - {{ items.length > 0 ? page * limit : items.length }} of {{ totalItems }}
						</button>
						<!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
						<md-menu-content>
							<md-menu-item @click="changeLimit(10)"><span class="text-center minw-50">10</span></md-menu-item>
							<md-menu-item @click="changeLimit(25)"><span class="text-center minw-50">25</span></md-menu-item>
							<md-menu-item @click="changeLimit(50)"><span class="text-center minw-50">50</span></md-menu-item>
							<md-menu-item @click="changeLimit(100)"><span class="text-center minw-50">100</span></md-menu-item>
							<md-menu-item @click="changeLimit(200)"><span class="text-center minw-50">200</span></md-menu-item>
						</md-menu-content>
					</md-menu>
				</div>
				<div>
					<input
						type="text"
						class="form-control"
						:placeholder="$t('Search')"
						@input="onKeywordChange"
						v-model="keyword"
					/>
				</div>
			</div>
			<!-- Main Table -->
			<table class="table table-striped mb-4">
				<thead>
					<tr>
						<th width="15%">{{ $t('No') }}</th>
						<th>{{ $t('Description') }}</th>
						<th>{{ $t('Action') }}</th>
						<th>{{ $t('Category') }}</th>
						<th>{{ $t('Date') }}</th>
					</tr>
				</thead>
				<div class="p-5 text-center absolute" v-if="isFetching">
					<div class="is-loading large"></div>
				</div>
				<tbody>
					<tr
						v-for="(item, index) in items"
						:key="item.id">
						<td>{{ numberingList(index) }}</td>
						<td>{{ item.description }}</td>
						<td class="capitalize">{{ replaceString(item.action) }}</td>
						<td class="capitalize">{{ replaceString(item.category) }}</td>
						<td class="capitalize">{{ getDate(item) }}</td>
					</tr>
				</tbody>
			</table>
			<div class="text-center absolute disabled mt-4" v-if="items.length === 0 && !isFetching">{{$t('No user log available')}}</div>
			<!-- Table Pagination -->
			<pagination
				v-if="!isFetching"
				:total-pages="totalPages"
				:current-page="page"
				:last-page="lastPage"
				@select="onPageSelected">
			</pagination>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import Pagination from '@/components/Pagination.vue';
import {
	getAxiosErrorMessage,
	delay,
	convertTimezone,
	addZeroUTC,
} from '@/lib/helper';
import userLogsApi from '@/api/user-log';

export default {
	name: 'UserLogs',
	components: {
		Pagination,
	},
	data() {
		return {
			page: 1,
			limit: 10,
			orderBy: 'id',
			sortBy: 'desc',
			keyword: '',
			isAll: false,
			items: [],
			totalItems: 0,
			lastPage: 1,
			title: 'User Logs',
			isFetching: false,
			category: '',
			action: '',
		};
	},
	methods: {
		fetch(reset = false, page) {
			this.isFetching = true;
			if (reset) {
				this.page = 1;
				this.items = [];
			}
			if (page) {
				this.page = page;
			}
			const params = this.fetchParams;
			const callback = (response) => {
				const items = response.data.data;
				if (items.length < this.limit) {
					this.isAll = true;
				}
				this.items = items;
				this.totalItems = response.data.total;
				this.lastPage = response.data.lastPage;
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Users',
					text: message,
				});
				this.isFetching = false;
			};
			userLogsApi.getLogs(params, callback, errorCallback);
		},
		onKeywordChange() {
			delay(() => {
				this.fetch(true);
			}, 500);
		},
		onPageSelected(page) {
			this.fetch(true, page);
		},
		numberingList(index) {
			if (this.page >= 1) {
				return index + 1 + (this.page * 10 - 10);
			}
			return index + 1;
		},
		changeLimit(value) {
			this.limit = value;
			this.fetch(true);
		},
		sortFilter(filter) {
			if (filter === 'asc') {
				this.sortBy = 'asc';
			} else {
				this.sortBy = 'desc';
			}
		},
		filterOrder(filter) {
			if (filter === 'all') {
				this.orderBy = 'id';
			} else if (filter === 'action') {
				this.orderBy = 'action';
			} else if (filter === 'category') {
				this.orderBy = 'category';
			} else {
				this.orderBy = 'created_at';
			}
		},
		replaceString(string) {
			return string.replaceAll('_', ' ');
		},
		convertUTC(date) {
			const d = new Date(date);
			const h = addZeroUTC(d.getUTCHours());
			const m = addZeroUTC(d.getUTCMinutes());
			const s = addZeroUTC(d.getUTCSeconds());
			return `${h}:${m}:${s}`;
		},
		getDate(item) {
			let time = '-';
			if (item.created_at) {
				if (!item.timezone) {
					time = item.created_at;
					time = new Date(time);
					const result = `${time.getDate()}-${(time.getMonth() + 1)}-${time.getFullYear()}/${this.convertUTC(item.created_at)}`;
					time = result;
				} else {
					time = convertTimezone(item.created_at, item.timezone);
				}
			}
			return time;
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		fetchParams() {
			const params = {
				page: this.page,
				limit: this.limit,
				order_by: this.orderBy,
				sort_by: this.sortBy,
				action: this.action,
				category: this.category,
			};
			const keyword = this.keyword.trim();
			if (keyword !== '') {
				params.keyword = keyword;
			}
			return params;
		},
		totalPages() {
			const total = Math.ceil(this.totalItems / this.limit);
			return total;
		},
	},
	created() {
		this.fetch();
	},
	watch: {
		sortBy() {
			this.fetch(true);
		},
		orderBy() {
			this.fetch(true);
		},
	},
};
</script>
